import { Injectable } from '@angular/core';
import { SavedSubscriptionModel } from 'src/app/core/model/object/shop-model';

@Injectable({
  providedIn: 'root',
})
export class ShopDataService {
  constructor() {}

  public getSubscription(): Promise<SavedSubscriptionModel> {
    const subsJson = localStorage.getItem('subscription');
    const subs = SavedSubscriptionModel.fromJSON(subsJson);
    if (subs) {
      return Promise.resolve(subs);
    }
  }

  public saveSubscription(res: SavedSubscriptionModel) {
    localStorage.setItem('subscription', JSON.stringify(res));
  }

  public removeSubscription() {
    localStorage.removeItem('subscription');
  }
}
